module.exports = __webpack_public_path__ + "static/media/h2.e3ead356.svg";